import { MaybeRef, computed, unref } from 'vue';
import vtkImageData from '@kitware/vtk.js/Common/DataModel/ImageData';
import { useVtkRepresentation } from '@/src/core/vtk/useVtkRepresentation';
import { Maybe } from '@/src/types';
import { View } from '@/src/core/vtk/types';
import vtkVolume from '@kitware/vtk.js/Rendering/Core/Volume';
import vtkVolumeMapper from '@kitware/vtk.js/Rendering/Core/VolumeMapper';
import { fitVolumeToGpu } from '@/src/utils/fitVolumeToGpu';

export function useVolumeRepresentation(
  view: View,
  imageData: MaybeRef<Maybe<vtkImageData>>
) {
  // Khối vượt MAX_3D_TEXTURE_SIZE của GPU -> hạ độ phân giải cho vừa (chỉ render 3D; 2D full-res).
  const volumeData = computed(() => {
    const img = unref(imageData);
    return img ? fitVolumeToGpu(img) : img;
  });

  const volRep = useVtkRepresentation({
    view,
    data: volumeData,
    vtkActorClass: vtkVolume,
    vtkMapperClass: vtkVolumeMapper,
  });

  return volRep;
}
